import { Point } from "highcharts";
import { generateBillingExplorerChartTooltipMarkup } from "../../../../../components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-chart/utils/helpers/tooltip/generateBillingExplorerChartTooltipMarkup";
import { Dates } from "../../../../../services/cloudchipr.api";
import { calculateFromToByDatesData } from "../../../../../components/common/date-range-picker/utils/helpers/calculateFromToByDatesData";

export const getPieChartTooltipValueFormatter = (
  dates?: Dates,
  quarterStartMonth?: number,
  totalCost?: number,
) => {
  const { toDate, fromDate } = calculateFromToByDatesData(
    dates ?? {},
    quarterStartMonth,
  );

  const date = fromDate && toDate ? `${fromDate} - ${toDate}` : "";

  return (point: Point) => {
    const name = point.name;
    const value = point.y ?? 0;
    const percent = point.percentage ?? 0;

    return generateBillingExplorerChartTooltipMarkup(
      date,
      name,
      `${point.color}`,
      value,
      percent,
      totalCost,
    );
  };
};
